import { $, bindClick } from "../lib/dom.js";
import { escHtml } from "../lib/hints.js";
import { api } from "../api.js";

/** 商家控制台「支付对账」：按笔列每一笔支付 + 那一次退款（2026-10-24 方案 v2）。 */

const PAY_STATUS_LABELS = {
  pending: "未支付",
  paid: "已收款",
  refund_processing: "退款中",
  refunded: "已退款",
};

const REFUND_STATUS_LABELS = {
  processing: "退款中",
  success: "退款成功",
  failed: "退款失败",
};

const PAGE_SIZE = 50;
let listPage = 1;
/** 展开明细的订单号；点行切换。 */
const expanded = new Set();

function fmtMoney(cents) {
  if (cents === null || cents === undefined) return "—";
  return `¥${(Number(cents || 0) / 100).toFixed(2)}`;
}

function fmtTime(iso) {
  const s = String(iso || "").trim();
  if (!s) return "—";
  return s.replace("T", " ").slice(0, 19);
}

function orderIdShort(id) {
  const s = String(id || "");
  if (s.length <= 24) return s;
  return `${s.slice(0, 10)}…${s.slice(-8)}`;
}

function badge(label, key) {
  if (!label) return '<span class="muted">—</span>';
  return `<span class="mc-mo-badge mc-mo-badge--${escHtml(key || "")}">${escHtml(label)}</span>`;
}

function payBadge(status) {
  const st = String(status || "");
  return badge(PAY_STATUS_LABELS[st] || st, st);
}

function refundBadge(status) {
  const st = String(status || "");
  if (!st) return '<span class="muted">—</span>';
  return badge(REFUND_STATUS_LABELS[st] || st, st);
}

function readFilters() {
  return {
    date_from: String(($("recon-date-from") || {}).value || "").trim(),
    date_to: String(($("recon-date-to") || {}).value || "").trim(),
    pay_status: String(($("recon-pay-status") || {}).value || "").trim(),
    refund_status: String(($("recon-refund-status") || {}).value || "").trim(),
  };
}

function buildQuery(filters, page) {
  const parts = [`page=${Math.max(1, Number(page) || 1)}`, `limit=${PAGE_SIZE}`];
  Object.keys(filters).forEach((k) => {
    if (filters[k]) parts.push(`${k}=${encodeURIComponent(filters[k])}`);
  });
  return parts.join("&");
}

function renderSummary(data) {
  const box = $("recon-summary");
  if (!box) return;
  const s = (data && data.summary) || {};
  const paidCents = Number(s.paid_amount_cents || 0);
  const refundCents = Number(s.refunded_amount_cents || 0);
  const netCents = paidCents - refundCents;
  box.innerHTML = `
    <span class="mc-recon-stat">匹配 <strong>${Number(data && data.total) || 0}</strong> 笔</span>
    <span class="mc-recon-stat">收款 <strong>${Number(s.paid_count) || 0}</strong> 笔 · <strong>${escHtml(fmtMoney(paidCents))}</strong></span>
    <span class="mc-recon-stat">已退款 <strong>${Number(s.refunded_count) || 0}</strong> 笔 · <strong>${escHtml(fmtMoney(refundCents))}</strong></span>
    <span class="mc-recon-stat">净收 <strong>${escHtml(fmtMoney(netCents))}</strong></span>
  `;
}

function detailRow(rec) {
  const rows = [
    ["交易号（微信）", rec.transaction_id],
    ["预支付单号", rec.prepay_id],
    ["退款单号（我方）", rec.out_refund_no],
    ["微信退款单号", rec.refund_id],
    ["退款原因", rec.refund_reason],
    ["退款申请时间", rec.refund_requested_at],
    ["顾客 ID", rec.person_id],
    ["对账行更新", fmtTime(rec.updated_at)],
  ].filter(([, v]) => v);
  const body = rows
    .map(([k, v]) => `<dt>${escHtml(k)}</dt><dd>${escHtml(String(v))}</dd>`)
    .join("");
  return `<tr class="mc-recon-detail"><td colspan="8"><dl class="mc-mo-meta">${body || "<dt>—</dt><dd>无更多字段</dd>"}</dl></td></tr>`;
}

function renderTable(items) {
  const box = $("recon-list");
  if (!box) return;
  if (!items.length) {
    box.innerHTML = '<p class="mc-mo-empty">该条件下暂无对账记录</p>';
    return;
  }
  const rows = items
    .map((r) => {
      const oid = String(r.order_id || "");
      const open = expanded.has(oid);
      const head = `<tr class="mc-mo-row mc-recon-row${open ? " mc-mo-row-selected" : ""}" data-oid="${escHtml(oid)}">
        <td><span class="mc-mo-oid" title="${escHtml(oid)}">${escHtml(orderIdShort(oid))}</span></td>
        <td>${payBadge(r.pay_status)}</td>
        <td><strong>${escHtml(fmtMoney(r.pay_amount_cents))}</strong></td>
        <td class="muted">${escHtml(fmtTime(r.paid_at || r.created_at))}</td>
        <td>${refundBadge(r.refund_status)}</td>
        <td>${r.refund_amount_cents === null || r.refund_amount_cents === undefined ? '<span class="muted">—</span>' : `<strong>${escHtml(fmtMoney(r.refund_amount_cents))}</strong>`}</td>
        <td class="muted">${escHtml(fmtTime(r.refunded_at))}</td>
        <td class="muted">${escHtml(String(r.pay_mode || ""))}</td>
      </tr>`;
      return head + (open ? detailRow(r) : "");
    })
    .join("");
  box.innerHTML = `<div class="mc-mo-table-wrap"><table class="mc-mo-table"><thead><tr>
    <th>订单号</th><th>支付状态</th><th>支付金额</th><th>支付时间</th>
    <th>退款状态</th><th>退款金额</th><th>退款时间</th><th>支付方式</th>
  </tr></thead><tbody>${rows}</tbody></table></div>`;
  box.querySelectorAll("tr.mc-recon-row").forEach((tr) => {
    tr.addEventListener("click", () => {
      const oid = tr.getAttribute("data-oid");
      if (!oid) return;
      if (expanded.has(oid)) expanded.delete(oid);
      else expanded.add(oid);
      renderTable(items);
    });
  });
}

function renderPager(data) {
  const box = $("recon-pager");
  if (!box) return;
  if (!data) {
    box.innerHTML = "";
    return;
  }
  const total = Number(data.total) || 0;
  const page = Number(data.page) || listPage;
  const size = Number(data.limit) || PAGE_SIZE;
  const pages = Math.max(1, Math.ceil(total / size));
  if (total <= size) {
    box.innerHTML = total ? `<span class="muted">共 ${total} 笔</span>` : "";
    return;
  }
  box.innerHTML = `
    <button type="button" id="btn-recon-prev" ${page <= 1 ? "disabled" : ""}>上一页</button>
    <span class="muted">第 ${page} / ${pages} 页 · 共 ${total} 笔</span>
    <button type="button" id="btn-recon-next" ${page >= pages ? "disabled" : ""}>下一页</button>
  `;
  bindClick("btn-recon-prev", () => {
    if (listPage <= 1) return;
    listPage -= 1;
    loadMallReconcilePanel();
  });
  bindClick("btn-recon-next", () => {
    if (listPage >= pages) return;
    listPage += 1;
    loadMallReconcilePanel();
  });
}

export async function loadMallReconcilePanel() {
  const filters = readFilters();
  const listBox = $("recon-list");
  if (listBox) listBox.innerHTML = '<p class="mc-mo-empty">加载中…</p>';
  const { ok, data } = await api(
    "GET",
    `/api/v1/fitting/merchant/mall/reconcile?${buildQuery(filters, listPage)}`
  );
  if (!ok) {
    if (listBox) {
      const msg =
        (data && data.error && (data.error.message || data.error.code)) ||
        (data && (data.message || data.detail)) ||
        "加载失败";
      listBox.innerHTML = `<p class="mc-mo-empty">加载失败：${escHtml(String(msg))}</p>`;
    }
    renderSummary(null);
    renderPager(null);
    return;
  }
  listPage = Number(data.page) || listPage;
  renderSummary(data);
  renderTable((data && data.items) || []);
  renderPager(data);
}

export function initMallReconcileHandlers() {
  bindClick("btn-recon-refresh", () => {
    listPage = 1;
    expanded.clear();
    loadMallReconcilePanel();
  });
  // 回车即查询，省得每次去点按钮
  ["recon-date-from", "recon-date-to"].forEach((id) => {
    const el = $(id);
    if (!el) return;
    el.addEventListener("keydown", (e) => {
      if (e.key !== "Enter") return;
      e.preventDefault();
      listPage = 1;
      loadMallReconcilePanel();
    });
  });
}
